import { useQuery } from "@tanstack/react-query";

import { getUserProfile } from "../api/userProfileApi";
import { userProfileKeys } from "../api/userProfileKeys";

export const useUserProfileQuery = () =>
    useQuery({
        queryKey: userProfileKeys.profile(),
        queryFn: getUserProfile,
    });
